import React from "react";

import _ from "underscore";
import AnalyticsTracking from "Utils/AnalyticsTracking";

const networkDescriptionsCopy = {
  HMO: "HMO plans use a small network of doctors to reduce costs, require specialist referrals, and do not cover out-of-network services.",
  HMP: "HMP plans provide out-of-network coverage but are not suitable for out-of-state employees",
  EPO: "EPO plans allow you to see any in-network doctor without a referral, but do not cover out-of-network services.",
  PPO: "PPO plans have the largest networks, allow you to see any doctor, and provide out-of-network coverage.",
  POS: "POS plans allow you to see any doctor, and provide out-of-network coverage.",
  Indemnity: "Indemnity plans allow you visit any doctor, and do not have a network.",
  multiple: "This package may offer different size networks. Your employee can choose the coverage that's right for them.",
};

const generateHelpCenterLink = (networkType) => (
  <a
    href="https://www.simplyinsured.com/advice/2016/11/18/health-insurance-network-types-ppo-vs-hmo"
    target="_blank"
    onClick={() => trackClick(networkType)}
    rel="noreferrer"
  >
    Learn more
  </a>
);

const trackClick = (networkType) =>
  AnalyticsTracking.trackEvent("link_clicked", {
    location: "network_tool_tip",
    network: networkType,
  });

export const NETWORK_DESCRIPTIONS = _.mapObject(networkDescriptionsCopy, (description, type) => (
  <span>
    {description} {generateHelpCenterLink(type)}
  </span>
));
